export const rules = {
  business: { required: true, message: "必填项", trigger: "blur" },
  store: { required: true, message: "必填项", trigger: "blur" },
  month: { required: true, message: "必填项", trigger: "blur" }
};



// WEBPACK FOOTER //
// ./src/views/rfm/rfmBuyerLevel/data.js